import { z } from "zod";

export const skuSchema = z.string().trim().min(1).max(100);

export const createProductVariantSchema = z.object({
  sku: skuSchema,
  name: z.string().trim().max(200).optional(),
  color: z.string().trim().max(100).optional(),
  size: z.string().trim().max(100).optional(),
  style: z.string().trim().max(100).optional(),
  condition: z.string().trim().max(30).optional(),
  quantity: z.number().int().min(0),
  rentalPriceOverride: z.number().min(0).optional(),
  salePriceOverride: z.number().min(0).optional(),
  replacementValueOverride: z.number().min(0).optional(),
});
export type CreateProductVariantInput = z.infer<typeof createProductVariantSchema>;

export const updateProductVariantSchema = z.object({
  name: z.string().trim().max(200).optional(),
  color: z.string().trim().max(100).optional(),
  size: z.string().trim().max(100).optional(),
  style: z.string().trim().max(100).optional(),
  condition: z.string().trim().max(30).optional(),
  quantity: z.number().int().min(0).optional(),
  rentalPriceOverride: z.number().min(0).optional(),
  salePriceOverride: z.number().min(0).optional(),
  replacementValueOverride: z.number().min(0).optional(),
});
export type UpdateProductVariantInput = z.infer<typeof updateProductVariantSchema>;
